import { render, staticRenderFns } from "./MpesaTransactions.vue?vue&type=template&id=6aa0cfed&scoped=true"
import script from "./MpesaTransactions.vue?vue&type=script&lang=js"
export * from "./MpesaTransactions.vue?vue&type=script&lang=js"
import style0 from "./MpesaTransactions.vue?vue&type=style&index=0&id=6aa0cfed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa0cfed",
  null
  
)

export default component.exports